<div class="d-flex justify-content-end align-items-center header-summary" *ngIf="languageMenu">
  <div class="language" *ngFor="let language of languageMenu">
    <a class="px-1" (click)="setLanguage(language.language)">{{ language.name }}</a>
  </div>
</div>
